import React, { FC, useState, type PropsWithChildren } from "react";
import AccordionSection from "./AccordionSection";
import { Switch } from "../../../../../components";
import type { ProfileLinkConfig } from "../../../../../client";

const SettingRow: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex items-center justify-between gap-2">{children}</div>
  );
};

const SettingText: FC<PropsWithChildren> = ({ children }) => {
  return <p className="text-gray-9 text-sm font-medium grow">{children}</p>;
};

interface ProjectsLinkSettingsProps {
  disabled?: boolean;
  linkConfig?: ProfileLinkConfig;
  onUpdate: (payload: Partial<ProfileLinkConfig>) => void;
}

const ProjectsLinkSettings: FC<ProjectsLinkSettingsProps> = ({
  disabled,
  linkConfig,
  onUpdate,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <AccordionSection
      title="Projects"
      subtitle={
        linkConfig?.projectsLinkConfig?.displaySkills
          ? "Display skills"
          : "Skills hidden"
      }
      expanded={isExpanded}
      onToggle={() => setIsExpanded(!isExpanded)}
    >
      <SettingRow>
        <Switch
          checked={linkConfig?.projectsLinkConfig?.displaySkills}
          disabled={disabled}
          onCheckedChange={(checked) => {
            if (typeof checked !== "boolean") return;

            onUpdate({
              projectsLinkConfig: {
                ...linkConfig?.projectsLinkConfig,
                displaySkills: checked,
              },
            });
          }}
        />
        <SettingText>Skills</SettingText>
      </SettingRow>
      <SettingRow>
        <Switch
          checked={linkConfig?.projectsLinkConfig?.displaySkillIcons ?? true}
          disabled={disabled}
          onCheckedChange={(checked) => {
            if (typeof checked !== "boolean") return;

            onUpdate({
              projectsLinkConfig: {
                ...linkConfig?.projectsLinkConfig,
                displaySkillIcons: checked,
              },
            });
          }}
        />
        <SettingText>Icons</SettingText>
      </SettingRow>
    </AccordionSection>
  );
};

export default ProjectsLinkSettings;
